import React, { useEffect, useState } from 'react';
import { Box, Button, Divider, Grid, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PageWrapper from 'components/Common/PageWraper';
import PageHeader from 'components/Header/Page';
import CustomSwitch from 'components/Button/CustomSwitch';
import { useTheme } from '@mui/material/styles';
import PepwiseCustomButton from 'components/Button/PepwiseCustomButton';
import CheckboxGroup from 'components/Checkboxes/CheckboxGroup';
import CustomCheckbox from 'components/Checkboxes/CustomCheckbox';
import { DeleteButton, DeleteButtonSecondary } from 'components/Common/PepV2DeleteButton';
import { RadioButtons } from 'components/Common/PepV2RadioButton';

export default function ButtonsPage() {
  const theme = useTheme();
  const colors = theme.palette;
  const navigate = useNavigate();
  const [checked, setChecked] = React.useState(false);
  const [toggleChecked, setToggleChecked] = useState(false);
  const [radioValue, setRadioValue] = useState('label-1');

  const [singleChecked, setSingleChecked] = useState(true);
  const [selectedValues, setSelectedValues] = useState<(string | number)[]>(['1']);
  const [selectedRowValues, setSelectedRowValues] = useState<(string | number)[]>(['2']);
  const options = [
    { label: 'Option 1', value: '1' },
    { label: 'Option 2', value: '2' },
    { label: 'Option 3', value: '3', disabled: true },
  ];

  useEffect(() => {
    console.log('Radio value:', radioValue);
  }, [radioValue]);

  return (
    <PageWrapper>
      <PageHeader title="Buttons Demo">
        <Button variant="pepwiseSecondary" onClick={() => navigate(-1)}>
          ← Back
        </Button>
      </PageHeader>

      <Grid container spacing={3} mt={2} px={2}>
        <Grid item xs={6} sm={3} md={2}>
          <CustomSwitch
            checked={checked}
            onChange={(checked) => {
              setChecked(checked);
              console.log('Switch is now:', checked);
            }}
            label="Critical"
            labelPlacement="start"
            fullWidth
            colors={{
              thumb: colors.toggle.thumb,
              trackOn: colors.toggle.trackOn,
              trackOff: colors.toggle.trackOff,
              thumbShadow: colors.toggle.thumbShadow,
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={2}>
          <PepwiseCustomButton
            label="Submit"
            variantType="solid"
            type="submit"
            fullWidth
            onClick={() => {
              console.log('Form submitted');
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={2}>
          <PepwiseCustomButton
            label="Save & Next"
            variantType="bordered"
            fullWidth
            onClick={() => {
              console.log('Save & Next clicked');
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={2}>
          <PepwiseCustomButton
            label="Cancel"
            variantType="text"
            fullWidth
            onClick={() => {
              console.log('Cancel clicked');
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={2}>
          <PepwiseCustomButton
            label="Submit"
            variantType="solid"
            disabled
            type="submit"
            fullWidth
            onClick={() => {
              console.log('Form submitted');
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={2}>
          <PepwiseCustomButton
            label="Save & Next"
            variantType="bordered"
            disabled
            fullWidth
            onClick={() => {
              console.log('Save & Next clicked');
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={2}>
          <PepwiseCustomButton
            label="Cancel"
            variantType="text"
            disabled
            fullWidth
            onClick={() => {
              console.log('Cancel clicked');
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={2}>
          <PepwiseCustomButton
            label="Apply"
            variantType="solid"
            type="submit"
            fullWidth
            onClick={() => {
              console.log('Apply clicked');
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={2}>
          <PepwiseCustomButton
            label="Clear"
            variantType="text"
            fullWidth
            onClick={() => {
              console.log('Clear clicked');
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Typography sx={{ fontSize: '16px', color: '#000', fontWeight: 500 }}>
              Single Checkbox
            </Typography>

            <CustomCheckbox
              label="Accept terms"
              checked={singleChecked}
              onChange={(checked) => setSingleChecked(checked)}
              size="medium"
            />

            <CustomCheckbox
              label="Accept terms - disabled"
              checked={singleChecked}
              onChange={(checked) => setSingleChecked(checked)}
              size="medium"
              disabled
            />

            <Typography sx={{ fontSize: '16px', color: '#000', fontWeight: 500 }}>
              Checkbox Group - Column
            </Typography>

            <CheckboxGroup
              label="Choose options"
              options={options}
              values={selectedValues}
              onChange={setSelectedValues}
              direction="column"
            />

            <Typography sx={{ fontSize: '16px', color: '#000', fontWeight: 500 }}>
              Checkbox Group - Row
            </Typography>

            <CheckboxGroup
              options={options}
              values={selectedRowValues}
              onChange={setSelectedRowValues}
              direction="row"
            />
          </Box>
        </Grid>
        
        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mb: 3, fontWeight: 700, color: '#000000' }}>
            Delete Button variations
          </Typography>
          <Stack direction="row" spacing={2}>
            <DeleteButton variant="temporary" onClick={() => { alert('Delete handler executed') }} title="temporary-delete-normal" />
            <DeleteButton variant="temporary" onClick={() => { alert('Delete handler executed') }} title="temporary-delete-borderless" borderLess />
            <DeleteButton variant="temporary" onClick={() => { alert('Delete handler executed') }} title="temporary-delete-disabled" disabled />
          </Stack>
          <Stack direction="row" spacing={2} mt={2}>
            <DeleteButton variant="permanent" onClick={() => {alert('Delete handler executed')}} title="permanent-delete"/>
            <DeleteButton variant="permanent" onClick={() => {alert('Delete handler executed')}} title="permanent-delete-borderless" borderLess />
            <DeleteButton variant="permanent" onClick={() => {alert('Delete handler executed')}} title="permanent-delete-disabled" disabled />              
          </Stack>
          <Stack direction="row" spacing={2} mt={2}>
            <DeleteButtonSecondary variant="temporary" onClick={() => {alert('Delete handler executed')}} title="secondary-temporary-delete"/>
            <DeleteButtonSecondary variant="temporary" onClick={() => {alert('Delete handler executed')}} title="secondary-temporary-delete-borderless" borderLess />
            <DeleteButtonSecondary variant="temporary" onClick={() => {alert('Delete handler executed')}} title="secondary-temporary-delete-disabled" disabled />              
          </Stack>
          <Stack direction="row" spacing={2} mt={2}>
            <DeleteButtonSecondary variant="permanent" onClick={() => {alert('Delete handler executed')}} title="secondary-permanent-delete"/>
            <DeleteButtonSecondary variant="permanent" onClick={() => {alert('Delete handler executed')}} title="secondary-permanent-delete-borderless" borderLess />
            <DeleteButtonSecondary variant="permanent" onClick={() => {alert('Delete handler executed')}} title="secondary-permanent-delete-disabled" disabled />              
          </Stack>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mb: 3, fontWeight: 700, color: '#000000' }}>
            Toggle variations
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="flex-start">
            <CustomSwitch
              checked={toggleChecked}
              onChange={(checked) => {
                setToggleChecked(checked)
              }}
              label={`Toggle ${toggleChecked ? 'ON ' : 'OFF'}`}
              labelPlacement="start"
              fullWidth
              colors={{
                thumb: colors.toggle.thumb,
                trackOn: colors.toggle.trackOn,
                trackOff: colors.toggle.trackOff,
                thumbShadow: colors.toggle.thumbShadow,
              }}
            />
            <CustomSwitch
              disabled
              checked={checked}
              onChange={(checked) => {}}
              label="Toggle disabled"
              labelPlacement="start"
              fullWidth
              colors={{
                thumb: colors.toggle.thumb,
                trackOn: colors.toggle.trackOn,
                trackOff: colors.toggle.trackOff,
                thumbShadow: colors.toggle.thumbShadow,
              }}
            />
          </Stack>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" sx={{ mb: 3, fontWeight: 700, color: '#000000' }}>
            Radio buttons
          </Typography>
          <Stack direction="column" spacing={2} justifyContent="flex-start">
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 400, color: '#000000' }}>
              Horizontal size 1:
            </Typography>
            <RadioButtons
              orientation='horizontal'
              options={[
                { label: 'label-1', value: 'label-1' },
                { label: 'label-2', value: 'label-2' },
                { label: 'label-3', value: 'label-3' },
                { label: 'label-4', value: 'label-4' },
              ]}
              onChange={((v: any) => setRadioValue(v))} value={radioValue}
            />
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 400, color: '#000000' }}>
              Horizontal size 2:
            </Typography>
            <RadioButtons
              size='medium'
              orientation='horizontal'
              options={[
                { label: 'label-1', value: 'label-1' },
                { label: 'label-2', value: 'label-2' },
                { label: 'label-3', value: 'label-3' },
                { label: 'label-4', value: 'label-4' },
              ]}
              onChange={((v: any) => setRadioValue(v))} value={radioValue}
            />
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 400, color: '#000000' }}>
              Vertical size 1:
            </Typography>
            <RadioButtons
              orientation='vertical'
              options={[
                { label: 'label-1', value: 'label-1' },
                { label: 'label-2', value: 'label-2' },
                { label: 'label-3', value: 'label-3' },
                { label: 'label-4', value: 'label-4' },
              ]}
              onChange={((v: any) => setRadioValue(v))} value={radioValue}
            />
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 400, color: '#000000' }}>
              Vertical size 2:
            </Typography>
            <RadioButtons
              orientation='vertical'
              size='medium'
              options={[
                { label: 'label-1', value: 'label-1' },
                { label: 'label-2', value: 'label-2' },
                { label: 'label-3', value: 'label-3' },
                { label: 'label-4', value: 'label-4' },
              ]}
              onChange={((v: any) => setRadioValue(v))} value={radioValue}
            />
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 400, color: '#000000' }}>
              Vertical & left side label placement:
            </Typography>
            <RadioButtons
              labelPosition='start'
              orientation='vertical'
              options={[
                { label: 'label-1', value: 'label-1' },
                { label: 'label-2', value: 'label-2' },
                { label: 'label-3', value: 'label-3' },
                { label: 'label-4', value: 'label-4' },
              ]}
              onChange={((v: any) => setRadioValue(v))} value={radioValue}
            />
          </Stack>
        </Grid>
      </Grid>
    </PageWrapper>
  );
}
